module.exports = __webpack_public_path__ + "img/National Syllabi Vs Job Market.30b2246c.svg";